var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dragzone-wrapper"},[_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"dropz",staticClass:"uploader",attrs:{"element-loading-text":"文件正在上传中,请稍后","element-loading-background":"rgba(0, 0, 0, 0.8)"}}),_c('div',{staticClass:"uploader-bg"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }